export default __webpack_public_path__ + "static/sp-kv-1-45c3e7e62fb9cde0523310ba89126bdc.png";